'use client';

/*
  This curious standalone component exists purely to avoid shoving the entire ArticleSwoops SVG paths into the client bundle. I need to use state here to toggle the `padding-top` based on whether a superheader is visible or not.
*/

import { styled } from '@linaria/react';

import { useGlobalUIState } from '@/components/GlobalUIProvider';

function SwoopWrapper({ children }: { children: React.ReactNode }) {
  const { superheader } = useGlobalUIState();

  return (
    <Wrapper
      style={{
        '--active-superheader-height': superheader
          ? '2.75rem'
          : '0rem',
      }}
    >
      {children}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding-top: calc(3rem + var(--active-superheader-height));
  background: linear-gradient(
    to bottom,
    var(--color-sky-from),
    var(--color-sky-to)
  );
  /* The swoops will almost certainly be wider than this container. Trim the overflow */
  overflow: hidden;
  overflow: clip;
`;

export default SwoopWrapper;
